/**
 * Every status a run can be in. Its own module so the built-in tools registry can read it without importing the
 * package index, which re-exports the registry.
 */
export const RUN_STATUSES = [
    /** Successor waiting for its task or member to free up. Holds no lock; promoted to `queued`. */
    'pending',
    'queued',
    'running',
    'waiting_on_gate',
    'waiting_on_run',
    'paused_spend',
    /**
     * Held at the start by a plan limit (#445): portal runs or runner minutes used up on a plan with no overage.
     * Holds no lock; resumes by itself when the plan changes or the period rolls. See `blockedReason`.
     */
    'paused_plan',
    /**
     * Held at the start because the run's own team is switched off (#1809). Holds no lock; resumes by itself when
     * the team is switched back on (`TeamEnforcementService`). See `blockedReason`.
     */
    'paused_team',
    /**
     * Held by a person's pause of its whole execution (#809): it had not started when the pause landed, or it was
     * started by a run the pause had stamped (`pausedAt`). Holds no lock, is no loop-cap lap and is not on Blockers.
     * Only Resume (back to `pending`, or to `blocked` for a held escalation) or Cancel moves it.
     */
    'paused',
    'succeeded',
    'failed',
    'cancelled',
    'skipped_overlap',
    /** Stopped on something outside the task (model, credentials, definition, loop cap). Holds no lock; see `blockedReason`. */
    'blocked',
] as const

export type RunStatus = (typeof RUN_STATUSES)[number]
